<div class="p-fluid">
  <form #floorPlanForm="ngForm" (ngSubmit)="onSubmit(floorPlanForm)">
    <div class="p-grid p-formgrid align-items-start">
      <div class="col-12 d-flex align-items-center">
        <div class="form-group col-6 p-1">
          <label for="unitName">Floor Plan Name</label>
          <input id="unitName" type="text" pInputText name="unitName" [(ngModel)]="floorPlan.unit" required />
        </div>
        <!-- <div class="form-group col-6 p-1">
          <label for="name">Name</label>
          <input
            id="name"
            type="text"
            pInputText
            name="name"
            [(ngModel)]="floorPlan.name"
            required
          />
        </div> -->
      </div>
      <div class="col-12 d-flex align-items-center">
        <div class="form-group col-6 p-1">
          <label for="minPrice">Min Price</label>
          <input id="minPrice" type="text" pInputText name="minPrice" [(ngModel)]="floorPlan.min_price" (blur)="validateMinMax()"
            (input)="validateNumber($event)" required />
        </div>
        <div class="form-group col-6 p-1">
          <label for="maxPrice">Max Price</label>
          <input id="maxPrice" type="text" pInputText name="maxPrice" [(ngModel)]="floorPlan.max_price" (blur)="validateMinMax()"
            (input)="validateNumber($event)" required />
        </div>
      </div>

      <div class="col-12 d-flex align-items-center">
        <div class="form-group col-6 p-1">
          <label for="sqFt">Min Square Feet</label>
          <input id="sqFt" type="number" pInputText name="sqFt" [(ngModel)]="floorPlan.sq_ft" (input)="validateNumber($event)" (blur)="validateMinMax('sqft')" min="1" required />
        </div>
        <div class="form-group col-6 p-1">
          <label for="max_sq_ft">Max Square Feet</label>
          <input id="max_sq_ft" type="number" pInputText name="max_sq_ft" [(ngModel)]="floorPlan.max_sq_ft" (input)="validateNumber($event)" (blur)="validateMinMax('sqft')" min="1" required />
        </div>
        <!-- <div class="form-group col-6 p-1">
              <label for="minDeposit">Min Deposit</label>
              <input
                id="minDeposit"
                type="number"
                pInputText
                name="minDeposit"
                [(ngModel)]="floorPlan.min_deposit"
                required
              />
            </div> -->
      </div>

      <!-- <div class="p-col-12 p-md-6">
        <div class="p-field">
          <label for="maxDeposit">Max Deposit</label>
          <input id="maxDeposit" type="number" pInputText name="maxDeposit" [(ngModel)]="floorPlan.max_deposit"
            required />
        </div>
      </div> -->

      <!-- <div class="col-12 d-flex align-items-center">
        <div class="form-group col-6 p-1">
          <label for="beds">Beds</label>
          <input id="beds" type="number" pInputText name="beds" [(ngModel)]="floorPlan.beds" min="1" max="99" step="1"
            (input)="allowOnlyIntegers('beds', $event)" required />
        </div>
        <div class="form-group col-6 p-1">
          <label for="baths">Baths</label>
          <input id="baths" type="text" pInputText name="baths" [(ngModel)]="floorPlan.baths"
          (input)="allowDecimalNumbers('baths', $event)" required />
        </div>
      </div> -->
      <div class="col-12 d-flex align-items-start">
        <!-- Beds -->
        <div class="form-group col-6 p-1">
          <div class="d-flex flex-column">
            <div class="form-group p-1">
              <label for="beds">Beds</label>
              <p-dropdown
              id="bedsSelect"
              name="bedsSelect"
              [options]="bedOptionsDropdown"
              [(ngModel)]="bedsSelect"
              placeholder="Select Beds"
              (onChange)="onSelectOther('beds')">
              </p-dropdown>
            </div>

            <div class="form-group p-1">
              <input
                type="text"
                class="form-control"
                name="bedsInput"
                [(ngModel)]="floorPlan.beds"
                min="0.5"
                max="99"
                step="0.5"
                placeholder="Enter beds"
                [hidden]="!editingBeds"
                (input)="allowDecimalNumbers('beds', $event)"/>
            </div>
          </div>
        </div>
          
        <!-- Baths -->
        <div class="form-group col-6 p-1">
          <div class="d-flex flex-column">
            <div class="form-group p-1">
              <label for="baths">Baths</label>
              <p-dropdown
              id="bathsSelect"
              name="bathsSelect"
              [options]="bathOptionsDropdown"
              [(ngModel)]="bathsSelect"
              placeholder="Select Baths"
              (onChange)="onSelectOther('baths')"
             ></p-dropdown>
            </div>
            <div class="form-group p-1">
              <div class="form-group p-1">
                <input
                  type="text"
                  class="form-control"
                  name="bathsInput"
                  min="0.5"
                  max="99"
                  step="0.5"
                  [(ngModel)]="floorPlan.baths"
                  placeholder="Enter baths"
                  [hidden]="!editingBaths"
                  (input)="allowDecimalNumbers('baths', $event)"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-12">
        <div class="form-group">
          <div class="d-flex align-items-center gap-2">
            <p-checkbox [(ngModel)]="floorPlan.waitlist" name="waitlist" binary="true"></p-checkbox>
            <label for="waitlist">Waitlist</label>
          </div>
        </div>
      </div> -->
      <div class="p-col-12">
        <div class="form-group p-field">
          <label for="description">Description</label>
          <textarea id="description" pInputTextarea name="description" [(ngModel)]="floorPlan.description"></textarea>
        </div>
      </div>


      <div class="p-field d-flex flex-column mt-3">
        <label for="image" class="custom-file-label">
          {{ selectedImage || floorPlan['image_title'] ? 'Change Image' : 'Choose an Image' }}
        </label>
        <input id="image" type="file" accept="image/*" (change)="onImageSelected($event)" class="hidden-file-input" />
        <div *ngIf="imagePreviewUrl" class="mt-3">
          <img [src]="imagePreviewUrl" alt="Selected Image" class="img-thumbnail"
            style="width: 100%; height: 200px; object-fit: contain;" />
          <small class="mt-1">{{ floorPlan['image_title'] || selectedImage?.name }}</small>
        </div>
        <!-- 
        <div *ngIf="selectedImage.image" class="mt-3">
          <img [src]="selectedImage.image" alt="Selected Image" class="img-thumbnail" style="max-width: 300px; max-height: 300px;" />
        </div> -->

        <div *ngIf="selectedImage || floorPlan['image_title']" class="mt-2">
          <p-button pbutton type="button" class="cancel-btn me-2" (click)="removeImage()">
            Delete
          </p-button>
        </div>
      </div>



      <div class="mt-3 d-flex justify-content-end">
        <p-button type="submit" class="secondary-btn" [disabled]="!isFloorPlanValid()">Submit</p-button>
      </div>
    </div>
  </form>
</div>

<p-toast></p-toast>